module.exports = __webpack_public_path__ + "static/media/screenshot(5).9c5b0f08.jpg";